import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { useT } from '_metronic/i18n/Metronici18n'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { DispositivoGestaoList } from '../../core/_models'
import { DispositivosColumns } from './columns/_columns'

export const DispositivosTable = () => {
  const { response, isLoading, isError, refetch } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const dados = useMemo(() => response?.data ?? [], [response])
  // Coluna Regime só quando alguma linha é Vendido: com o mesmo valor em todas, ela não informa.
  const mostrarRegime = dados.some((d) => d.regime === 'VENDIDO')
  const situacoesVisiveis = useMemo(() => dados.map((d) => d.situacao), [dados])
  const columns = useMemo(
    () => DispositivosColumns(t, { mostrarRegime, situacoesVisiveis }),
    [t, mostrarRegime, situacoesVisiveis]
  )

  const emptyState = (
    <TableEmptyState
      title={t('pagina.dispositivos.vazio.titulo')}
      description={t('pagina.dispositivos.vazio.descricao')}
      action={
        hasFilters
          ? { label: t('pagina.dispositivos.limpar_filtros'), onClick: clearFilters }
          : undefined
      }
    />
  )

  return (
    <CustomTable<DispositivoGestaoList>
      id='kt_table_dispositivos'
      ariaLabel={t('menu.dispositivos')}
      itemLabel={{ singular: 'dispositivo', plural: 'dispositivos' }}
      data={dados}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
